<template>
  <div>
    <!--  Heat Table  -->
    <div class="container" style="margin-top: 70px">
     <table-leaders ref='tableLeaders' :datos='table.data' :limitSelection='table.limitSelection' @setFilterTable='setFilterTable'></table-leaders>
    </div>
  </div>
</template>

<script>
import tableLeaders from '../components/tableLeaders.vue'
export default {
  data() {
    return {
      table: {
        data: [],
        limitSelection: 1,
        filters: {}
      },
      filters: {
        leader: null
      },
    }
  },
  props: {
    proceso: {
      type: Object
    },
    dataLideres: {
      type: Object,
      required: true
    },
    dependencias: {
      type: Array
    }
  },
  beforeMount() {
    // this.getData()
  },
  methods: {
    // Data
    getData(){
      if (this.dataLideres.data) {
        this.table.data = this.dataLideres.data
      }
    },
    // Others
    setFilterTable(filters) {
      const id = filters.length ? filters[0].empleado._id : null
      if (this.filters.leader) {
        if (id) {
          this.filters.leader = id
        } else {
          this.filters.leader = ""
        }
      } else {
        this.filters.leader = id
      }
    },
  },
  created() {},
  watch: {
    'filters.leader'(v) {
      this.$emit('changeIdLider', v)
    },
    dataLideres() {
      this.getData()
    }
  },
  components:{
    tableLeaders
  }
}
</script>

<style scoped lang="scss">

/* Backgrounds Rangos */

.rango1 {
  background-color: #f4cdcd !important;
  color: white;
}

.rango2 {
  background-color: #facca5 !important;
  color: white;
}

.rango3 {
  background-color: #fff2cc !important;
  color: white;
}

.rango4 {
  background-color: #d9ead3 !important;
  color: white;
}

.rango5 {
  background-color: #a2c4c9 !important;
  color: white;
}

.rango6 {
  background-color: #c8d9f7 !important;
  color: white;
  /* color: rgba(65, 64, 64, 0.91); */
}

.rango0 {
  background-color: rgba(175, 174, 174, 0.81);
  color: white;
}

/* Backgrounds RangosAutoc */

.AltaAuto{
  background-color: #d9ead3 !important;
}

.MediaAuto{
  background-color: #fff2cc !important;
}

.BajoAuto{
  background-color: #f4cdcd !important;
}

.SinResultadosAuto{
  background-color: rgba(175, 174, 174, 0.81);
}

/* Table */
.heat-table {
  border: 1px solid #c2c2c2;
  /* agregar codigo para que sea responsive */
}

.heat-table thead {
  border: 1px solid #dbdbdb;
}

.heat-table tbody {
  border: 1px solid #dbdbdb;
}

.heat-table th {
  border: 1px solid #dbdbdb;
}

.heat-table td {
  border: 1px solid #dbdbdb;
}

.scroll-table {
  height: 306px;
  overflow-y: auto;
  overflow-x: auto;
}

.head-stick th {
  background: white;
  position: sticky;
  top: -3px; /* Don't forget this, required for the stickiness */
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
  z-index: 60 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/ResultadoLiderazgo/ResulParte2.vue